<svelte:head>
    <title>404 Page Not Found | MyWeb Tunisie</title>
</svelte:head>

<nav class="fixed w-full z-20 top-0 left-0 border-b border-gray-200 myweb-header-blur">
	<div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
	<a href="/" class="flex items-center">
		<img src="/assets/brand/mywebtext.webp" class="h-10 mr-3" alt="Flowbite Logo">
	</a>
	<div class="flex md:order-2">
		<a href="#pricing"><button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center mr-3 md:mr-0">Get started</button></a>
		<button data-collapse-toggle="navbar-sticky" type="button" class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200   " aria-controls="navbar-sticky" aria-expanded="false">
		  <span class="sr-only">Open main menu</span>
		  <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
		</button>
	</div>
	<div class="items-center justify-between hidden w-full md:flex md:w-auto md:order-1" id="navbar-sticky">
	  <ul class="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg md:flex-row md:space-x-8 md:mt-0 md:border-0">
		<li>
		  <a href="/" class="block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0">Home</a>
		</li>
		<li>
		  <a href="#/about" class="block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0">About</a>
		</li>
		<li>
		  <a href="/#/featured" class="block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0">Featured</a>
		</li>
		<li>
		  <a href="/#/contact" class="block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0">Contact</a>
		</li>
	  </ul>
	</div>
	</div>
</nav>  
<div class="w-full h-16"></div>

<section class="bg-white dark:bg-gray-900 bg-[url('/assets/other/hero-pattern.svg')]">
    <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div class="mx-auto max-w-screen-sm text-center">
            <h1 class="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 dark:text-primary-500">404</h1>
            <p class="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">Page not found.</p>
            <p class="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">The page you are looking for does not exist.</p>
        </div>   
    </div>
</section>
